const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

const INSTAGRAM_MEDIA_HOST_SUFFIXES = [
  'cdninstagram.com',
  'fbcdn.net',
  'instagram.com',
];

const isInstagramMediaUrl = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    const normalizedHost = hostname.toLowerCase();

    return INSTAGRAM_MEDIA_HOST_SUFFIXES.some(
      (suffix) => normalizedHost === suffix || normalizedHost.endsWith(`.${suffix}`)
    );
  } catch {
    return false;
  }
};

export const getMediaUrl = (url?: string | null): string => {
  const normalizedUrl = url?.trim();

  if (!normalizedUrl) {
    return '';
  }

  if (!isInstagramMediaUrl(normalizedUrl)) {
    return normalizedUrl;
  }

  return `${API_BASE}/api/insights/media-proxy?url=${encodeURIComponent(normalizedUrl)}`;
};

export const getAvatarFallbackUrl = (username: string, size: number = 32): string => {
  const displayName = username.replace(/[._]/g, ' ');

  return `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=0ea5e9&color=fff&size=${size}&bold=true`;
};

export const getProfilePictureUrl = (
  username: string,
  profilePicUrl?: string | null,
  size: number = 32
): string => {
  if (profilePicUrl?.trim()) {
    return getMediaUrl(profilePicUrl);
  }

  return getAvatarFallbackUrl(username, size);
};
